__turbopack_context__.v({
  "cardsContainer": "serviceCards-module-scss-module__eZcvcG__cardsContainer",
  "sectionTitle": "serviceCards-module-scss-module__eZcvcG__sectionTitle",
  "serviceCards": "serviceCards-module-scss-module__eZcvcG__serviceCards",
});
